var angular = require('angular');
var _module = require('./index');


_module.directive('complianceSlide', [function () {
    return {
        restrict: 'E',
        templateUrl: 'js/components/modals/templates/compliance-slide.tmpl.html',
        scope: {
            report: '=',
            isMobile: '='
        },
        bindToController: true,
        controllerAs: 'vm',
        controller: [
            function () {
                var vm = this;
            }
        ]
    };
}]);
